import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=8b29322e&scoped=true&"
import script from "./recent.vue?vue&type=script&lang=js&"
export * from "./recent.vue?vue&type=script&lang=js&"
import style0 from "./recent.vue?vue&type=style&index=0&id=8b29322e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b29322e",
  null
  
)

export default component.exports